// Alpine.js Safety Checks
(function() {
  'use strict';
  
  console.log('Initializing Alpine.js safety checks...');
  
  // Function to safely access Alpine stores
  function safeAlpineStore(storeName, property, value) {
    try {
      if (typeof Alpine !== 'undefined' && Alpine.store && Alpine.store(storeName)) {
        const store = Alpine.store(storeName);
        if (property && value !== undefined) {
          store[property] = value;
        }
        return store;
      }
      return null;
    } catch (error) {
      console.log(`Alpine store ${storeName} not available:`, error);
      return null;
    }
  }
  
  // Function to safely call Alpine store methods
  function safeAlpineMethod(storeName, methodName, ...args) {
    try {
      const store = safeAlpineStore(storeName);
      if (store && typeof store[methodName] === 'function') {
        return store[methodName](...args);
      }
      return null;
    } catch (error) {
      console.log(`Alpine method ${storeName}.${methodName} not available:`, error);
      return null;
    }
  }
  
  // Override problematic Alpine store calls
  function addSafetyChecks() {
    // Wait for Alpine to be available
    if (typeof Alpine === 'undefined') {
      setTimeout(addSafetyChecks, 100);
      return;
    }
    
    // Add safety wrapper for common store methods
    const originalStore = Alpine.store;
    Alpine.store = function(name, store) {
      // If it's a function, wrap it with safety checks
      if (typeof store === 'function') {
        const originalInit = store;
        store = function() {
          try {
            return originalInit.apply(this, arguments);
          } catch (error) {
            console.log(`Error initializing Alpine store ${name}:`, error);
            return {};
          }
        };
      }
      
      return originalStore.call(this, name, store);
    };
    
    console.log('Alpine.js safety checks added');
  }
  
  // Initialize safety checks
  addSafetyChecks();
  
  // Export safe functions for use in other scripts
  window.AlpineSafety = {
    safeStore: safeAlpineStore,
    safeMethod: safeAlpineMethod
  };
  
})(); 

